import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "auth-form__section terms-agreement" }
const _hoisted_2 = {
  key: 0,
  class: "auth-form__section-title"
}
const _hoisted_3 = { class: "terms-agreement__notice" }
const _hoisted_4 = { class: "auth-form__agreements" }
const _hoisted_5 = { class: "auth-form__agree-all" }
const _hoisted_6 = { class: "terms-agreement__label" }
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "terms-agreement__text" }
const _hoisted_9 = ["onClick"]

import { computed, ref } from 'vue'
import TermsModal from '@/components/auth/TermsModal.vue'
import {
  COMPANY,
  LEGAL_DOCS,
  MARKETING_CONSENT_SECTIONS,
  PRIVACY_COLLECTION_ROWS,
  PRIVACY_CONSENT_SECTIONS,
  TERMS_OF_SERVICE_SECTIONS,
  type LegalDocType,
} from '@/constants/legalContent'

export type AgreementId = 'age' | 'terms' | 'privacy' | 'marketing'

export type AgreementState = Record<AgreementId, boolean>


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsAgreementSection',
  props: {
    modelValue: {},
    hideTitle: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const agreementItems = [
  { id: 'age' as const, label: '만 14세 이상입니다.', required: true },
  { id: 'terms' as const, label: '이용약관 동의', required: true, docType: 'service' as LegalDocType },
  { id: 'privacy' as const, label: '개인정보 수집·이용 동의', required: true, docType: 'privacy-consent' as LegalDocType },
  { id: 'marketing' as const, label: '마케팅·광고성 정보 수신 동의', required: false, docType: 'marketing' as LegalDocType },
]

const modalOpen = ref(false)
const activeDocType = ref<LegalDocType | null>(null)

const allChecked = computed({
  get: () => agreementItems.every((item) => props.modelValue[item.id]),
  set: (checked: boolean) => {
    const next = { ...props.modelValue }
    agreementItems.forEach((item) => {
      next[item.id] = checked
    })
    emit('update:modelValue', next)
  },
})

const activeDoc = computed(() => (activeDocType.value ? LEGAL_DOCS[activeDocType.value] : null))

const activeSections = computed(() => {
  if (!activeDocType.value) return []
  if (activeDocType.value === 'service') return TERMS_OF_SERVICE_SECTIONS
  if (activeDocType.value === 'privacy-consent') return PRIVACY_CONSENT_SECTIONS
  if (activeDocType.value === 'marketing') return MARKETING_CONSENT_SECTIONS
  return []
})

const activePrivacyRows = computed(() =>
  activeDocType.value === 'privacy-consent' ? PRIVACY_COLLECTION_ROWS : undefined,
)

const onItemChange = (id: AgreementId, checked: boolean) => {
  emit('update:modelValue', { ...props.modelValue, [id]: checked })
}

const openDoc = (docType: LegalDocType) => {
  activeDocType.value = docType
  modalOpen.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!__props.hideTitle)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "약관 동의"))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.hideTitle ? '필수만 동의하셔도 가입됩니다. 만 14세는 본인 확인용입니다.' : `${_unref(COMPANY).serviceName} 서비스 이용을 위해 아래 약관에 동의해 주세요.`), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allChecked).value = $event)),
          type: "checkbox",
          class: "auth-form__checkbox"
        }, null, 512), [
          [_vModelCheckbox, allChecked.value]
        ]),
        _cache[2] || (_cache[2] = _createTextVNode(" 전체 동의 ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "terms-agreement__all-note" }, "필수·선택 항목을 포함합니다.", -1))
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(agreementItems, (item) => {
        return _createElementVNode("div", {
          key: item.id,
          class: "terms-agreement__item"
        }, [
          _createElementVNode("label", _hoisted_6, [
            _createElementVNode("input", {
              checked: __props.modelValue[item.id],
              type: "checkbox",
              class: "auth-form__checkbox",
              onChange: ($event: any) => (onItemChange(item.id, ($event.target as HTMLInputElement).checked))
            }, null, 40, _hoisted_7),
            _createElementVNode("span", {
              class: _normalizeClass(["terms-agreement__badge", item.required ? 'terms-agreement__badge--required' : 'terms-agreement__badge--optional'])
            }, _toDisplayString(item.required ? '필수' : '선택'), 3),
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1)
          ]),
          (item.docType)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "terms-agreement__view",
                onClick: ($event: any) => (openDoc(item.docType))
              }, " 내용 보기 ", 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ]),
    _createVNode(TermsModal, {
      open: modalOpen.value,
      title: activeDoc.value?.title ?? '',
      "updated-at": activeDoc.value?.updatedAt,
      sections: activeSections.value,
      "privacy-rows": activePrivacyRows.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (modalOpen.value = false))
    }, null, 8, ["open", "title", "updated-at", "sections", "privacy-rows"])
  ]))
}
}

})